export default __webpack_public_path__ + "images/955221834085709cbcd8236eeb5bcb6d-food_and_drink.png";